import React, { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  selectedPositionsAvailable,
  selectExpandDeclineFiles,
  selectExpandFileOut,
} from '@AMIEWEB/NewOrder/Store/Order.selectors';
import { Grid } from '@mui/material';
import { GlanceFieldTitle } from '@AMIEWEB/Order/OrderDetails/OrderDetailsDesign';
import { GlanceValue } from '@AMIEWEB/Order/OrderDetails/OrderAtAGlance/GlanceValue';
import { atAGlanceSection } from '@AMIEWEB/NewOrder/Store/helper';

const PositionFileOutReason = () => {
  const { t } = useTranslation();
  const { control, formState: { errors } } = useFormContext();
  const currentPositionValue = useWatch({
    name: 'positionsAvailable',
  });

  const positionValue = useSelector(selectedPositionsAvailable);
  const isExpandFileOut = useSelector(selectExpandFileOut);
  const isExpandDeclineFiles = useSelector(selectExpandDeclineFiles);

  const [expandFileOut, setExpandFileOut] = useState<boolean>(false);
  const [expandDeclineFiles, setExpandDeclineFiles] = useState<boolean>(false);

  useEffect(() => {
    setExpandFileOut(isExpandFileOut);
    setExpandDeclineFiles(isExpandDeclineFiles);
  }, [isExpandFileOut, isExpandDeclineFiles]);

  return (
    <>
      {atAGlanceSection.map((glanceValues, key) => (
        <React.Fragment key={key}>
          {expandDeclineFiles && glanceValues.title === 'File Out*' && (
            <Grid container item xs={12} width={'22vw'}>
              <Grid item xs={3} marginTop={'4px'}>
                <GlanceFieldTitle>{glanceValues?.title}</GlanceFieldTitle>
              </Grid>
              <Grid item xs={9} alignItems="center">
                <Controller
                  control={control}
                  name={glanceValues.value}
                  defaultValue={false}
                  render={({ field: { onChange, value, ...rest } }) => (
                    <GlanceValue
                      title={glanceValues.title}
                      value={value}
                      name={glanceValues?.value}
                      editable={glanceValues?.editable}
                      editTypeValue={glanceValues?.editableType}
                      handleOrderUpdate={(property: string, newValue: any) => {
                        onChange(newValue);
                      }}
                      disableEdit={false}
                      editedOrder={undefined}
                    />
                  )}
                />
              </Grid>
            </Grid>
          )}

          {expandFileOut && glanceValues.title === 'Reason*' && (
            <>
              <Grid item xs={11} style={{ marginBottom: 10 }}>
                <Controller
                  control={control}
                  name={glanceValues.value}
                  rules={{
                    required: 'Required',
                    validate: value => {
                      if (
                        typeof currentPositionValue === 'number' &&
                        currentPositionValue < positionValue &&
                        currentPositionValue >= 0
                      ) {
                        return value ? true : true;
                      }
                      return true;
                    },
                  }}
                  render={({ field }) => (
                    <GlanceValue
                      editOrderPage
                      errorField={!!errors?.orderDecrementReasonID}
                      title={glanceValues.title}
                      key={key}
                      value={field.value}
                      name={glanceValues?.value}
                      editable={glanceValues?.editable}
                      editTypeValue={glanceValues?.editableType}
                      handleOrderUpdate={(property: string, value: any) => {
                        field.onChange(value);
                      }}
                      editedOrder={undefined}
                      disableEdit={false}
                    />
                  )}
                />
              </Grid>
            </>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default PositionFileOutReason;
